export default __webpack_public_path__ + "static/media/homeicon.e2dc4976.svg";